import { StyledButton } from 'component/button_components/button_general/ButtonGeneralStyle';
import TransferDataComponent from 'component/form_component/transferDataBox';
import ModalOpenLoader from 'component/loader_component/modalOpenLoader';
import { SweetSweetAlert } from 'component/sweetalert_components';
import { FigCaption } from 'pages/license/style';
import { ButtonWrap } from 'pages/settings_page/style';
import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { getDomainExportAttribute, updateDomainExportAttribute } from 'redux/slices/settingsSlice';
import { getAttributes } from 'redux/slices/userSlice';

const ExportAttribute = ({ ...record }) => {
  const dispatch = useDispatch();
  const [titles, setTitles] = useState([]);
  const [loading, setLoading] = useState(false);
  const [apiAttribute, setApiAttribute] = useState([]);
  const [allowedTitles, setAllowedTitles] = useState([]);
  const { userAttributes } = useSelector((state) => state.getUsers);
  const { domainExportAttributeLoader, domainExportAttributeData } = useSelector((state) => state.settings);

  const Attributes = [
    'Display Name',
    'First Name',
    'Initial',
    'Last Name',
    'UPN',
    'SAM Name',
    'Email',
    'OU Name',
    'Associated Groups',
    'Lock Status',
    'Status',
    'Created On',
    'Last Changed',
    'Street',
    'PO.Box',
    'City',
    'State',
    'Zip',
    'Country',
    'JobTitle',
    'Company',
    'Department',
    'Description',
    'Telephone Number',
    'Office',
    'WebPage',
    'Disabled On',
    'Locked On',
    'Distinguished Name',
  ];

  const mergedArrray = [
    ...Attributes.map((item) => ({
      title: item,
      key: item,
    })),
    ...userAttributes.map((item) => ({
      title: item.charAt(0).toUpperCase() + item.slice(1),
      key: item.charAt(0).toUpperCase() + item.slice(1),
    })),
  ];

  useEffect(() => {
    dispatch(getAttributes(record.id));
    dispatch(getDomainExportAttribute(record.id));
  }, []);

  useEffect(() => {
    if (domainExportAttributeData) {
      const attributesFromAPI = domainExportAttributeData.map((item) => ({
        title: item,
        key: item,
      }));
      setApiAttribute(attributesFromAPI);
      setAllowedTitles(attributesFromAPI.map((item) => item.title));
    }
  }, [domainExportAttributeData]);

  const keysWithAllowedAttributes = mergedArrray
    .filter((attr) => apiAttribute.some((allowedAttr) => allowedAttr.key === attr.key))
    .map((item) => item.key);

  const handleTransferChange = (addedData, direction, removedData) => {
    const dataAdded = addedData.map((item) => item.title);
    const dataRemoved = removedData.map((item) => item.title);
    const updatedTitles = allowedTitles.filter((title) => !dataRemoved.includes(title));
    dataAdded.forEach((title) => {
      if (!updatedTitles.includes(title)) {
        updatedTitles.push(title);
      }
    });
    setTitles(updatedTitles);
  };

  const handleSubmit = async () => {
    try {
      setLoading(true);
      const response = await dispatch(
        updateDomainExportAttribute({
          domainId: record.id,
          attributeNames: titles,
        })
      );
      if (response?.payload?.status === 200) {
        SweetSweetAlert({ sweetData: response.payload.data, icon: 'success', buttonColor: 'green' });
        dispatch(getDomainExportAttribute(record.id));
        setTitles([]);
      } else {
        SweetSweetAlert({ text: 'Something Wrong Please try again.!!', icon: 'error', buttonColor: 'red' });
      }
    } catch (error) {
      SweetSweetAlert({ text: 'Something Wrong Please try again.!!', icon: 'error', buttonColor: 'red' });
    } finally {
      setLoading(false);
    }
  };

  return (
    <>
      {(loading || domainExportAttributeLoader) && <ModalOpenLoader />}
      <div className='af-superadmin-domain-setting-content-fifth-wrap' style={{ marginTop: 20 }}>
        <div style={{ marginBottom: 20 }}>
          <TransferDataComponent
            className='af-domain-setting-export-transferbox'
            leftBoxData={mergedArrray}
            rightBoxData={keysWithAllowedAttributes}
            onChange={handleTransferChange}
            leftBoxTitle={'Available fields '}
            rightBoxTitle={'Fields to be exported'}
          />
        </div>

        <ButtonWrap className='af-superadmin-domain-setting-button-wrap'>
          <StyledButton
            disabled={!titles.length}
            onClick={handleSubmit}
            className='af-superadmin-domain-setting-button'
            type='primary'
            htmlType='submit'
          >
            Submit
          </StyledButton>
        </ButtonWrap>
        <FigCaption style={{ color: '#3d3d3de6' }}>
          ** The export process may take long time if you add <b>Disabled On</b> and/or <b>Locked On</b> attributes
          based on amount of users locked/disabled.
        </FigCaption>
      </div>
    </>
  );
};

export default ExportAttribute;
